<template>
    <b-card
        no-body
        bg-variant="dark"
        style="min-width: 300px;"
        class="mb-3 dense"
    >
        <b-card-header>
            <h4>
                {{ server.nickname || server.name }}
            </h4>
        </b-card-header>
        <b-card-body v-if="show">
            <p>Name: {{ server.name }}</p>
            <p>Address: {{ server.publicAddress }}</p>
            <p>Upload served: {{ server.upload | formatData }}</p>
            <p>Download served: {{ server.download | formatData }}</p>
        </b-card-body>
        <b-card-body v-if="loading">
            <Spinner text="Loading" />
        </b-card-body>
    </b-card>
</template>

<script>
    import Spinner from '@/components/general/spinner'

    export default {
        props: ['id'],
        data() {
            return {
                show: false,
                loading: false
            }
        },
        methods: {
            load() {
                if (this.show) this.show = false
                else {
                    this.loading = true
                    return this.$store
                        .dispatch('user/servers/loadByID', this.id)
                        .then(() => {
                            this.loading = false
                            this.show = true
                        })
                }
            }
        },
        created() {
            this.load()
        },
        computed: {
            server() {
                return this.$store.getters['user/servers/getByID'](this.id)
            }
        },
        components: {
            Spinner
        }
    }
</script>